import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "img_con" }
const _hoisted_2 = ["src", "alt", "fetchpriority", "loading", "decoding"]
const _hoisted_3 = { class: "banner-content" }

import { ref, computed, onMounted } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import { detectDeviceFromUA } from '@/utils/deviceDetect'
import OverLayText from './overLayText.vue';

interface imageAltItem {
  imgUrl: string;
  alt?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
    bannerImages: {},
    hover: { type: Boolean },
    BannerHeight: {}
  },
  setup(__props: any) {

const props = __props;

const currentIndex = ref(0);

const onSlideChange = (swiper: any) => {
  currentIndex.value = swiper.realIndex;
};

const bannerHeight = computed(() => {
  if (typeof window !== 'undefined') {
    if (window.innerWidth <= 480) {
      return 320;  // 改为 @banner-height-mobile
    }
    if (window.innerWidth <= 768) {
      return 380;  // 改为 @banner-height-tablet
    }
  }
  return 550;  // 改为 @banner-height-desktop
});

const onSwiper = (swiper: any) => {
  if (props.bannerImages.length > 1 && swiper.autoplay) {
    swiper.autoplay.start();
  }
};

// 图片预加载逻辑
const preloadImages = () => {
  if (typeof window === 'undefined' || !props.bannerImages.length) return;

  // 创建一个新的 Image 对象用于预加载
  const preloadImage = (src: string) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  };

  // 使用 Promise.all 并行预加载所有图片
  const preloadPromises = props.bannerImages.map(image => 
    preloadImage(image.imgUrl)
  );

  Promise.all(preloadPromises)
    .catch(error => {
      console.warn('Some images failed to preload:', error);
    });
};

// 在组件挂载后开始预加载
onMounted(() => {
  if (typeof window !== 'undefined') {
    // 使用 requestIdleCallback 在浏览器空闲时预加载
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(() => preloadImages());
    } else {
      // 降级处理：使用 setTimeout
      setTimeout(preloadImages, 0);
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "banner",
    style: _normalizeStyle({ height: bannerHeight.value + 'px' })
  }, [
    _createVNode(_unref(Swiper), {
      modules: [_unref(Autoplay), _unref(Pagination), _unref(Navigation)],
      "slides-per-view": 1,
      loop: _ctx.bannerImages.length > 1,
      autoplay: _ctx.bannerImages.length > 1 ? {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      pagination: _ctx.bannerImages.length > 1 ? {
        clickable: true,
        dynamicBullets: true
      } : false,
      navigation: _ctx.bannerImages.length > 1,
      speed: 800,
      observer: true,
      "observer-parents": true,
      rewind: true,
      onSwiper: onSwiper,
      onSlideChange: onSlideChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerImages, (image, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("img", {
                  src: image.imgUrl,
                  alt: image.alt || 'Banner Image',
                  width: "1920",
                  height: "1080",
                  class: _normalizeClass(["banner-image", { 'hover-pause': _ctx.hover }]),
                  fetchpriority: index === 0 ? 'high' : 'auto',
                  loading: index === 0 ? 'eager' : 'lazy',
                  decoding: index === 0 ? 'sync' : 'async',
                  importance: "high"
                }, null, 10, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                  true
                    ? (_openBlock(), _createBlock(OverLayText, {
                        key: 0,
                        "is-active": currentIndex.value === index
                      }, null, 8, ["is-active"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules", "loop", "autoplay", "pagination", "navigation"])
  ], 4))
}
}

})